import { Component } from '@angular/core';
import { RemoveBlockedProductsStepComponent } from 'gung-standard';
import { first, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-hl-display-remove-blocked-products-step',
  templateUrl: './hl-display-remove-blocked-products-step.component.html',
  styleUrls: ['./hl-display-remove-blocked-products-step.component.css'],
  standalone: false
})
export class HlDisplayRemoveBlockedProductsStepComponent extends RemoveBlockedProductsStepComponent {
  protected checkBlockedProducts(): void {
    this.onNextBtnClicked.pipe(first()).subscribe(() => {
      this.cartService
        .getCurrentCart()
        .pipe(first())
        .subscribe(currentCartRows => {
          const productIds = currentCartRows.map(cartRow => cartRow.productId);

          // forkJoin over zero observables completes without emitting, which would leave
          // the checkout stuck on this invisible step - skip the lookup for empty carts - see https://support.gung.se/a/tickets/683295
          if (productIds.length === 0) {
            this.stepDone.emit(this.checkout);
            return;
          }

          forkJoin({
            cartRows: of(currentCartRows),
            blockedProducts: this.productService.getBlockedProducts(productIds).pipe(first()),
            products: forkJoin(productIds.map(id => this.productService.getProduct(id).pipe(first())))
          }).subscribe(({ cartRows, blockedProducts, products }) => {
            const blockedProductsIds = new Set<string>();
            const rowsToRemove: any[] = [];
            const replacementLines: string[] = [];

            for (const productId of Object.keys(blockedProducts)) {
              if (blockedProducts[productId]) {
                const blockedCartRows = cartRows.filter(cr => cr.productId === productId);
                if (!!blockedCartRows) {
                  rowsToRemove.push(...blockedCartRows);
                  blockedProductsIds.add(productId);

                  const product = products.find(p => p.id === productId);
                  const cartRow = currentCartRows.find(row => row.productId === productId);
                  const replacementId = product?.extra?.ar?.ersattsavartnr;
                  if (replacementId) {
                    replacementLines.push(`${productId} → ${replacementId}`);
                    this.cartService.addToCart(replacementId, cartRow.qty);
                  }
                }
              }
            }

            this.cartService.bulkRemoveRows(rowsToRemove);

            if (blockedProductsIds.size > 0) {
              let msg = '';

              if (replacementLines.length > 0) {
                msg +=
                  this.translateService.instant('BLOCKED_PRODUCTS_REPLACED_MESSAGE') +
                  '\n' +
                  replacementLines.join(', ') +
                  '\n\n';
              }

              msg += this.translateService.instant('BLOCKED_PRODUCTS_MESSAGE', {
                products: [...blockedProductsIds.values()].join(', ')
              });

              this.modalService
                .openConfirmYesNoModal(this.translateService.instant('BLOCKED_PRODUCTS'), msg, null, 'OK', null)
                .then(_ => { });
            }

            this.stepDone.emit(this.checkout);
          });
        });
    });
  }
}
